const logos = [
  { name: 'Stripe', file: 'stripe.webp' },
  { name: 'PayPal', file: 'paypal.png' },
  { name: 'Shoptet Pay', file: 'shoptet_pay.jpeg' },
  { name: 'WooCommerce', file: 'woocommerce.jpg' },
  { name: 'Mews', file: 'mews.webp' },
  { name: 'Money S3', file: 'moneyS3.webp' },
  { name: 'Comgate', file: 'comgate.jpg' },
  { name: 'Upgates', file: 'upgates.png' },
];

export default function LogoBar() {
  return (
    <div className="logo-bar">
      <div className="container">
        <div className="logo-bar-label">Synchronizujeme data z 25+ systémů do Money S3</div>
        <div className="logo-bar-logos">
          {logos.map(l => (
            <img key={l.name} src={`/integrations/${l.file}`} alt={l.name} title={l.name} />
          ))}
        </div>
      </div>
    </div>
  );
}
